import React from "react";
import Moment from "react-moment";
import { useTranslation } from "react-i18next";

import URL from "../../../../constant/URL";
import http from "../../../../http/http";
import useLoading from "../../../../hooks/useLoading";
import { useUserInfo } from "../../../../hooks";
import { TYPE } from "../../../../constant";

const LearningNoteCourse = (props) => {
  const { t, i18n } = useTranslation();
  const { setLoading, clearLoading } = useLoading();
  const { info } = useUserInfo();
  const [list, setList] = React.useState([]);

  const renderDelay = () => {
    return (
      <div className="lower">
        <div className="red_box">
          <span>
            <img
              src={`${process.env.PUBLIC_URL}/static/images/icon/ic_notice_red.svg`}
              alt=""
            />
            {t("LC_03_05_01.msg015")}
          </span>
        </div>
      </div>
    );
  };

  const renderStudyDate = () => {
    let div = <div></div>;
    if (list?.status === "COMPLETED-LEARNING") {
      // div = <div className="days"><span>학습기간 : {list?.term}</span><span>실제 학습일 : {list?.lrnDay} 일</span></div>;
      div = (
        <div className="days">
          <span>{t("LC_03_05_02.msg003")} : {list?.term}</span>
        </div>
      );
    }
    return div;
  };

  const setStatus = (status, sort) => {
    let div;
    if (sort === "hide_t") {
      if (status === "BEFORE-LEARNING") {
        div = (
          <img
            className="state1"
            // src={`${process.env.PUBLIC_URL}/static/images/icon/ic_status_1_mo_pc.svg`}
            src={
              i18n.language === 'en'
                ? `${process.env.PUBLIC_URL}/static/images/icon/ic_status_1_mo_en.svg`
                : `${process.env.PUBLIC_URL}/static/images/icon/ic_status_1_mo_pc.svg`
            }
            alt=""
          />
        );
      } else if (status === "NOW-LEARNING") {
        div = (
          <img
            className="state2"
            height={info.channelCode === TYPE.CHANNEL.GLOBAL01 ? '38' : ''}
            src={
              i18n.language === 'en'
                ? `${process.env.PUBLIC_URL}/static/images/icon/ic_status_2_tv_th_eng.svg`
                : `${process.env.PUBLIC_URL}/static/images/icon/ic_status_2_mo.svg`
            }
            alt=""
          />
        );
      } else if (status === "COMPLETED-LEARNING") {
        div = (
          <img
            className="state3"
            height={info.channelCode === TYPE.CHANNEL.GLOBAL01 ? '38' : ''}
            src={
              i18n.language === 'en'
                ? `${process.env.PUBLIC_URL}/static/images/icon/ic_status_3_tv_th_eng.svg`
                : `${process.env.PUBLIC_URL}/static/images/icon/ic_status_3_mo.svg`
            }
            alt=""
          />
        );
      }
    } else {
      if (status === "BEFORE-LEARNING") {
        div = (
          <img
            className="state1"
            height={info.channelCode === TYPE.CHANNEL.GLOBAL01 ? '38' : ''}
            src={
              i18n.language === 'en'
                ? `${process.env.PUBLIC_URL}/static/images/icon/ic_status_1_tv_th_eng.svg`
                : `${process.env.PUBLIC_URL}/static/images/icon/ic_status_1_tv_th.svg`
            }
            alt=""
          />
        );
      } else if (status === "NOW-LEARNING") {
        div = (
          <img
            className="state2"
            src={
              i18n.language === 'en'
                ? `${process.env.PUBLIC_URL}/static/images/icon/ic_status_2_tv_th_eng.svg`
                : `${process.env.PUBLIC_URL}/static/images/icon/ic_status_2_tv_th.svg`
            }
            alt=""
          />
        );
      } else if (status === "COMPLETED-LEARNING") {
        div = (
          <img
            className="state3"
            src={
              i18n.language === 'en'
                ? `${process.env.PUBLIC_URL}/static/images/icon/ic_status_3_tv_th_eng.svg`
                : `${process.env.PUBLIC_URL}/static/images/icon/ic_status_3_tv_th.svg`
            }
            alt=""
          />
        );
      }
    }

    return div;
  };

  const setCdNm = (item) => {
    let color = "red";
    if (item.cdNm === t("LC_03_05_01.msg012")) {
      color = "yellow";
    } else if (item.cdNm === t("LC_03_05_01.msg013")) {
      color = "green";
    } else if (item.cdNm === t("LC_03_05_01.msg010")) {
      color = "purple";
    }
    return (
      <div className={`ico_area ${color}`}>
        <span>{i18n.language === 'ko' && item.cdNm}</span>
      </div>
    );
  };

  const setState = (list) => {
    if (list) {
      return list.map((item, index) => (
        <div className="line cls" key={index}>
          <div className="date">
            <Moment format="YYYY.MM.DD">{item.lrnEndDt}</Moment>
          </div>
          {/* {i18n.language === 'ko' && setCdNm(item)} */}
          {setCdNm(item)}
        </div>
      ));
    }
  };

  const emptyList = () => {
    return (
      <div className="empty">
        <span>{t("LC_03_05_01.msg009")}</span>
      </div>
    );
  };

  const renderList = () => {
    if (list?.stgListByLvl) {
      return list?.stgListByLvl.map((item, index) => (
        <article key={index}>
          <div className="upper cls">
            <div className="num">{index + 1}</div>
            <div className="tit">{item?.stgNm}</div>
            <div className="state">{setState(item?.noteEndDtListByStg)}</div>
            <div className="btn_area">
              <button
                className="result_btn"
                onClick={(e) => props.moveResult(e, item)}
              >
                {t("LC_03_05_01.msg014")}
              </button>
            </div>
          </div>
          {item.delay ? renderDelay() : ""}
        </article>
      ));
    } else {
      return <div></div>;
    }
  };

  const getCourseList = () => {
    setLoading({ isShowSpinner: true, spinnerType: "4" });
    let data = {};

    if (props?.learner && props?.level) {
      http.request({
        url: `${URL.API.COURSE_LEARNING.NOTE}`
          + `/magnitude/channel/${info.channelCode}`
          + `/language/KO`
          + `/learners/${props.learner}`
          + `/level/${props.level}`,
        method: http.METHOD.POST,
        data,
        success: (res) => {
          clearLoading();
          let lastCnt = res?.stgListByLvl?.length - 1;
          let lastStage = res?.stgListByLvl[lastCnt];
          let lastStageNoteEnd = res?.stgListByLvl[lastCnt]?.noteEndDtListByStg;
          let length = lastStageNoteEnd?.length;

          if (length >= 3) {
            let cnt = 0;
            // 최신 학습결과가 노력3회 연속일 때
            for (let i = 0; i < 3; i++) {
              if (lastStageNoteEnd[i].lrnPrgsStsCd === "LPSC01") {
                cnt = cnt + 1;
              }
            }
            if (cnt >= 3) {
              lastStage.delay = true;
            }
          }
          setList(res);
        },
        error: (err) => {
          if (err) {
            clearLoading();
          }
        },
      });
    } else {
      clearLoading();
    }
  };

  const onChangeFlag = () => {
    props.onChangeFlag(true);
  };

  React.useEffect(getCourseList, [props?.learner, props?.level]);
  React.useEffect(() => {
    onChangeFlag();
  }, []);

  return (
    <>
      <div className="tit_n_state cls">
        <div className="tit tit_blue_16">{list?.lvlNm}</div>
        {
          list?.status && (
            <div className="state_ico">
              
              {
                info.channelCode !== TYPE.CHANNEL.GLOBAL01 && (
                  <>
                    <span className="hide_t">{setStatus(list?.status, "hide_t")}</span>
                    <span className="hide_pc hide_m">
                      {setStatus(list?.status, "hide_m")}
                    </span>
                  </>
                )
              }
            </div>
          )
        }
      </div>
      {renderStudyDate()}
      <div className="progress_list">
        {list?.stgListByLvl?.length === 0 ? emptyList() : renderList()}
      </div>
    </>
  );
};

export default LearningNoteCourse;
